import {
  type ProjectItem,
  useProduct,
} from '@customink/project-service-react-components';

import SizeChips from '../SizeChips';

import type { ModalState } from '@/atoms/editSizesModalAtoms';

type ProjectItemSizesProps = {
  editSizes?: (modalState: ModalState) => void;
  item: ProjectItem;
};

export const ProjectItemSizes = ({
  editSizes,
  item,
}: ProjectItemSizesProps) => {
  const { data: productData } = useProduct({ colorId: item.product?.colorId });

  const shouldRenderSizeChips =
    item.sizesQuantities &&
    item.sizesQuantities.length > 0 &&
    (productData?.sizes ?? []).length !== 1;

  if (!shouldRenderSizeChips) return null;
  return <SizeChips item={item} onChipClick={editSizes} />;
};
